import React from 'react';

const AdsScreen = () => {
  return (
    <div className='w-full grid grid-col-1 place-items-center'>Coming Soon</div>
  );
};

export default AdsScreen;
